import { addDays as dateFnsAddDays } from 'date-fns';
import parseDate from './parseDate';

const addDays = (dateTime, days) => {
  const parsedDateTime = parseDate(dateTime);

  return parsedDateTime ? dateFnsAddDays(parsedDateTime, days) : null;
};

export default addDays;
